/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'simayi-1': {
    sides: [
      { f: 'wei', n: '魏', l: '司馬懿', w: 1 },
      { f: 'han', n: '孟達', l: '孟達、鄧賢、李輔' },
      { f: 'shu', n: '蜀、吳援軍', l: '向木闌塞、西城安橋來救' },
    ],
    before: '孟達原是蜀將，降魏後當新城太守，文帝死後心不自安，暗中和吳、蜀往來。諸葛亮故意讓他的密謀洩露，逼他起事。孟達算定司馬懿要先上表、等洛陽回覆，一個月後才到得了。',
    after: '司馬懿先寫信穩住孟達，倍道兼行，八日就到上庸城下。圍城十六天，鄧賢、李輔開門出降，孟達被斬，首級傳到京師。',
    src: '《晉書·宣帝紀》；《三國志·明帝紀》及注引《魏略》',
  },
  'simayi-2': {
    sides: [
      { f: 'wei', n: '魏', l: '司馬懿、郭淮、辛毗', w: 1 },
      { f: 'shu', n: '蜀', l: '諸葛亮、楊儀、姜維' },
    ],
    before: '青龍二年，諸葛亮率十餘萬人出斜谷，屯在五丈原，分兵屯田打算久住。司馬懿渡過渭水背水立營，郭淮先據北原。朝廷知道蜀軍遠來利在急戰，一再命令司馬懿持重。',
    after: '兩軍對壘百餘日，諸葛亮送來巾幗也逼不出司馬懿。諸葛亮病死軍中，蜀軍撤退；楊儀反旗鳴鼓，司馬懿沒有逼近。百姓編出「死諸葛走生仲達」（又見《漢晉春秋》，裴注引）。',
    src: '《晉書·宣帝紀》；《三國志·諸葛亮傳》注引《漢晉春秋》、《郭淮傳》',
  },
  'simayi-3': {
    sides: [
      { f: 'wei', n: '魏', l: '司馬懿、牛金、胡遵', w: 1 },
      { f: 'han', n: '公孫淵', l: '公孫淵、卑衍、楊祚' },
    ],
    before: '公孫氏割據遼東三代，公孫淵自立為燕王，又向東吳稱臣求援。景初二年，司馬懿帶步騎四萬出征，說「往百日，攻百日，還百日，以六十日為休息，一年足矣」。公孫淵派卑衍、楊祚在遼隧築長圍阻擋。',
    after: '司馬懿聲東擊西渡過遼水，不攻遼隧，直撲襄平，三戰皆捷。霖雨三十多日按兵不動，雨停才合圍。公孫淵突圍時在梁水邊被斬，遼東、帶方、樂浪、玄菟都平定了。',
    src: '《晉書·宣帝紀》；《三國志·公孫度傳》',
  },
  'simayi-4': {
    sides: [
      { f: 'jin', n: '司馬懿', l: '司馬懿、司馬師、蔣濟、高柔', w: 1 },
      { f: 'wei', n: '曹爽', l: '曹爽、曹羲、桓範' },
    ],
    before: '明帝臨終，託司馬懿和曹爽一起輔佐少主。曹爽任用何晏、鄧颺、丁謐，獨攬朝政。司馬懿稱病兩年，李勝來探時他裝得奄奄一息，曹爽從此不再防備。',
    after: '嘉平元年正月，曹爽兄弟陪天子去拜高平陵，司馬懿趁機奏請太后、接管兩營，屯兵洛水浮橋。曹爽不聽桓範的建議，信了「只免官」的保證，交出兵權。不久曹爽一黨被誅，魏的大權從此歸於司馬氏。',
    src: '《晉書·宣帝紀》；《三國志·曹爽傳》及注引《魏末傳》《世語》',
  },
};
